
import { Vue, Component, Prop } from 'vue-property-decorator';

import { omegaup } from '../../omegaup';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import CountryFlag from '../CountryFlag.vue';
import common_Paginator from '../common/Paginator.vue';
import common_Typeahead from '../common/Typeahead.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getBlogUrl } from '../../urlHelper';

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-countryflag': CountryFlag,
    'omegaup-common-paginator': common_Paginator,
    'omegaup-common-typeahead': common_Typeahead,
  },
})
export default class SchoolRank extends Vue {
  @Prop() page!: number;
  @Prop() length!: number;
  @Prop() showHeader!: boolean;
  @Prop() totalRows!: number;
  @Prop() rank!: omegaup.SchoolsRank[];
  @Prop() pagerItems!: types.PageItem[];
  @Prop({ default: () => [] }) searchResultSchools!: types.SchoolListItem[];

  T = T;
  ui = ui;
  searchedSchool: null | types.SchoolListItem = null;

  get SchoolRankingFeatureGuideURL(): string {
    // Use the key defined in blog-links-config.json
    return getBlogUrl('SchoolRankingFeatureGuideURL');
  }

  onSubmit(): void {
    if (!this.searchedSchool) return;
    window.location.href = `/schools/profile/${encodeURIComponent(
      this.searchedSchool.key,
    )}/`;
  }
}
